import { render, staticRenderFns } from "./eyeball.vue?vue&type=template&id=52a8f055&scoped=true&lang=pug&"
import script from "./eyeball.vue?vue&type=script&lang=js&"
export * from "./eyeball.vue?vue&type=script&lang=js&"
import style0 from "./eyeball.vue?vue&type=style&index=0&id=52a8f055&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a8f055",
  null
  
)

export default component.exports